import React from 'react';
import { configure, mount } from 'enzyme';
import Adapter from 'enzyme-adapter-react-16';
import ConfigurationContent from './ConfigurationContent';
import LinFeatureSelection from '../ContentPages/Linux/FeatureSelection/LinFeatureSelection';
import WinSummary from '../ContentPages/WindowsCustom/Summary/WinSummary';
import {
    CUSTOM_INSTALL,
    WINDOWS,
    EXPRESS_INSTALL,
    LINUX,
    M11_5_03,
    WINDOWS_11_5_03_CUSTOM,
    LINUX_11_5_03,
    WINDOWS_11_5_03_EXPRESS,
} from '../../Utils/Constants';
import { loadData } from '../../Utils/DataLoader';

configure({ adapter: new Adapter() });

let wrapper = null;
describe('ConfigurationContent', () => {
    beforeEach(() => {
        jest.mock('../Navigation/Navigation.js', () => 'Nav');
        wrapper = mount(
            <ConfigurationContent
                nextStep={jest.fn()}
                backStep={jest.fn()}
                steps={5}
                getOriginState={jest.fn().mockReturnValue('mock state value')}
                setOriginState={jest.fn()}
                setBasicState={jest.fn()}
                deepestStep={5}
                useOs={WINDOWS}
                useMode={CUSTOM_INSTALL}
                useVersion={M11_5_03}
            />
        );
    });

    it('Test if set all products in Windows Custom, the fifth should be WebMobileVDS', () => {
        loadData(WINDOWS_11_5_03_CUSTOM);
        wrapper.setProps({ steps: 6, useOs: WINDOWS, useMode: CUSTOM_INSTALL });
        expect(wrapper.contains(LinFeatureSelection)).toEqual(true);
    });

    it('Test if set all products in Linux, the second should be LinFeatureSelection', () => {
        loadData(LINUX_11_5_03);
        wrapper.setProps({ steps: 3, useOs: LINUX });
        expect(wrapper.contains(LinFeatureSelection)).toEqual(true);
    });

    it('Test if set all products in Windows Express, the second should be WinSummary', () => {
        loadData(WINDOWS_11_5_03_EXPRESS);
        wrapper.setProps({
            steps: 1,
            useOs: WINDOWS,
            useMode: EXPRESS_INSTALL,
        });
        expect(wrapper.contains(WinSummary)).toEqual(true);
    });
});
